import React from 'react';
import Loading from 'react-loading';
import DialogBox from '../Common/DialogBox';
import {DragDropContext} from 'react-beautiful-dnd';
import DropZone from './DropZone';
import {Glyphicon} from 'react-bootstrap';
import {dynamicOEButtonCall} from '../../actions/API';
import APIResponseDialog from '../Common/APIResponseDialog';
import CustomToolTip from '../Common/CustomToolTip';
import {get} from '../../actions/REST';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

class Container extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      collapsed: this.props.container.config.collapsed || false,
    };
  }

  toggleCollapse(){
    this.setState(prevState => ({
      collapsed: !prevState.collapsed,
    }));
  }

  getRightHeader(){
    const glyph = this.state.collapsed ? "triangle-bottom" : "triangle-top";
    return (
      <div style={{float:'right',cursor:'pointer'}} onClick={this.toggleCollapse.bind(this)}>
        {<Glyphicon glyph={glyph} />}
      </div>
    );
  }

  render() {
    const { container } = this.props;
    const visibility = this.state.collapsed ? {display: 'none'} : {};

    return (
      <div className="container-wrapper" style={this.props.wrapperStyle}>
        <div className={"container-header " + container.config.class}>
          <div className="header-icon">
            <CustomToolTip
              icon={container.config.icon}
              iconClass={container.config.iconClass}
            />
          </div>
          {container.config.label}
          {this.getRightHeader()}
        </div>
        <div className="container-body" style={this.props.bodyStyle ? Object.assign({}, this.props.bodyStyle, visibility) : visibility}>
          {this.props.getZonesWrapper(container.zones)}
        </div>
      </div>
    );
  }
}

export default class OperationsBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialog_box: {
        show: false,
        data: null,
        uniqueID: "",
      },
      api_info: {
        endpoint: "",
        endpoint_type: "",
        method: "",
        variables: [],
      },
      screenHeader: {
        label: "",
        class: "",
        navigation: null,
      },
      cols: [],
      zones: [],
      dialog: {
        open: false,
        response: null,
      },
    };
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount(){
    this.props.data.data.ribbon && this.props.updateRibbon && this.props.updateRibbon(this.props.data.data.ribbon, true);
    this.props.data && this.props.data.data && this.props.data.data.config && this.parseData(this.props.data.data);
  }

  componentWillUpdate(nextProps){
    this.props !== nextProps && nextProps.data && nextProps.data.data && nextProps.data.data.config && this.parseData(nextProps.data.data)
  }

  getZone(zone){
    if(!zone.data){
      console.warn("data property is missing");
    }else if(!Array.isArray(zone.data)){
      console.warn("data should be an array, if you want an empty zone add data:[]");
    }
    const data = zone.data || [];
    return {
      id: zone.config.id,
      label: zone.config.label,
      api_info: {
        endpoint: zone.config.endpoint,
        endpoint_type: zone.config.endpoint_type,
        method: zone.config.method,
        variables: zone.config.variables,
        onDrop: {
          action: zone.config.ondrop,
          button: zone.config,
        },
      },
      data,
    };
  }

  parseData({ config }){

    const screenHeader = {
      label: config.label,
      class: config.class,
      navigation: config.navigation,
      seldate: config.seldate,
    };
    let zones = [];
    if (config && Array.isArray(config.cols)) {
    for(let col of config.cols){
      if(col.containers && col.containers.length > 0){
        for(let container of col.containers){
          for(let zone of container.zones){
            if(!zone.config){//If there's no config we "skip" the zone entirely
              console.warn("zone is missing config");
              continue;
            }
            zones.push(this.getZone(zone));
          }
        }
      }else if(col.rows && col.rows.length > 0){
        for(let row of col.rows){
          for(let zone of row.zones){
            if(!zone.config){//If there's no config we "skip" the zone entirely
              console.warn("zone is missing config");
              continue;
            }
            zones.push(this.getZone(zone));
          }
        }
      }else {
        continue;
      }
    }
    } else {
      console.warn('Might be missing cols property');
    }

    this.setState({
      zones,
      screenHeader,
      cols: config.cols || [],
    });
  }

  openDialog(response){
    // just bump it open then immediately close on this end, to leave timing
    // up to the dialog component
    this.setState({
      dialog: {
        open: true,
        response: response
      }
    }, () => this.setState({dialog: {open: false, response: response}}));
  }

  //Close the DialogBox and delete the data from the state
  closeDialogBox(){
    this.reverseTemoraryState(() =>
      this.setState({
        loading: false,
        dialog_box: {
          show: false,
          data: null,
          variables: null,
        },
      })
    );
  }

  /*
  ** Open the DialogBox passing the button clicked as the data
  **
  ** param {Object} - data
  ** param {String} - dialog_type
  */
  openDialogBox(data, dialog_type, uniqueID, variables){
    this.setState({
      loading: false,
      dialog_box: {
        uniqueID,
        data: data,
        show: true,
        dialog_type,
        variables,
      },
    });
  }

  getDialogBoxData(button, uniqueID, variables){
    if(button.endpoint){
      this.setState({loading: true});
      get(variables, `/${button.endpoint}`, 'Fetching data for DialogBox').then(response => {
        if(response.status >= 200 && response.status < 300){
          if(response && response.data && (response.data.config || (response.data.data && response.data.data.config))){
            this.openDialogBox(response.data, button.dialog_type, uniqueID, variables);
          }else{
            /* If it's a successful response (200 - 299) but the format is not correct, must likely is a
            ** back-end error. So we clear the LOADING state and we call the APIDialog.*/
            this.openAPIDialog({//faking the correct response when there's an Error in the API
              data: {
                errmsg: response.data,
              }
            });
          }
        }else {//If it wasn't a successful response then let's open the APIDialog
          this.setState({loading: false}, () => this.openAPIDialog(response));
        }
      });
    }else {//inline dialogBox
      this.openDialogBox(button, button.dialog_type, uniqueID, variables);
    }
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    //withing the same Drop-Zone
    if(result.source.droppableId === result.destination.droppableId){
      return this.setState(prevState => {
        //find the origin
        let zone_to_change = prevState.zones.filter(zone => ("zone_"+zone.id) === result.source.droppableId)[0];
        //re-order the list
        const ordered_data = reorder(
          zone_to_change.data,
          result.source.index,
          result.destination.index
        );
        //change the list to the ordered_data
        zone_to_change.data = ordered_data;
        return {
          zones: prevState.zones.filter(zone => ("zone_"+zone.id) !== result.source.droppableId)
            .concat(zone_to_change),
        };
      });
    }
    //When moving to another Drop-Zone
    if(result.source.droppableId !== result.destination.droppableId){
      let endpoint,
          method,
          onDrop;
      let variables = {};
      let temp_element = null;
      for(let zone of this.state.zones){
        if(("zone_" + zone.id) === result.source.droppableId){
          for(let item of zone.data){//We go through the Items in the Zone where we Originated the drag
            if((item.label+item.id) === result.draggableId){
              temp_element = item;
              temp_element["temporary"] = true;
              if(item.variables){
                variables = Object.assign({}, variables, item.variables);//Save the ID of the element being dragged to send as params
              }
            }
          }
        }
        if(("zone_" + zone.id) === result.destination.droppableId){
          endpoint = zone.api_info.endpoint;
          method = zone.api_info.method;
          onDrop = zone.api_info.onDrop;
          if(zone.api_info.variables){
            variables = Object.assign({}, variables, zone.api_info.variables);
          }
        }
      }
      this.setState(prevState => {
        let zone_to_change = prevState.zones.filter(zone => ("zone_"+zone.id) === result.destination.droppableId)[0];
        //Modifying the ID to avoid Unregistering issues with React-Beautiful-DND
        zone_to_change.data.push(Object.assign({}, temp_element, {id: "temporary"}));
        return {
          zones: prevState.zones.filter(zone => ("zone_"+zone.id) !== result.destination.droppableId)
            .concat(zone_to_change)
        }
      });
      if(onDrop.action == "dialog"){
        this.getDialogBoxData(onDrop.button, onDrop.action, variables);
      }else {
        dynamicOEButtonCall(`/${endpoint}`, method, variables).then(response => {
          if(!response){
            this.reverseTemoraryState(() => this.openDialog({data: {errmsg: 'Unable to perform this action.'}}));
          }
          if(response.status >= 200 && response.status < 300){
            this.openDialog(response);
            this.props.refreshObjects(this.state.screenHeader.seldate);
          }else {//Reverse the temporary state
            this.reverseTemoraryState(() => this.openDialog(response));
          }
        });
      }
    }
  }

  reverseTemoraryState(APIDialogCallback){
    this.setState(prevState => ({
      zones: prevState.zones.map(zone =>
        Object.assign({}, zone, {
          data: zone.data.filter(item => item.id != "temporary").map(item =>
            Object.assign({}, item, {
              temporary: false}
            )
          )
        })
      )
    }), APIDialogCallback);
  }

  getZonesWrapper(zones){
    let rendered_zones = [];
    for(let zone of zones){
      let items = this.state.zones.filter(state_zone => state_zone.id === zone.config.id)[0];
      rendered_zones.push(
        <DropZone
          key={zone.config.id}
          header={zone.config.label}
          extraClass={zone.config.class}
          buttonbar={zone.config.buttonbar}
          lbuttonbar={zone.config.lbuttonbar}
          isDropDisabled={zone.config.drop_disabled}
          droppableId={"zone_"+zone.config.id}
          refreshObjects={() => this.props.refreshObjects(this.state.screenHeader.seldate)}
          items={items.data}
        />
      );
    }
    return rendered_zones;
  }

  getContainers(col){
    const displayFlex = {
      display:'flex',
      flexWrap:'wrap',
    };
    let displayInline = {
      display:'inline-block',
      verticalAlign:'top',
      width: 'auto',
      marginRight:'10px',
    };
    if(col.rows && Array.isArray(col.rows)){
      let alternateLayout = false;
      return col.rows.map((container, index) => {
        if(index == 0 && container.config.id == 'ptocat'){
          //Alternate Layouts
          alternateLayout = true;
        }
        if(index == 1 && alternateLayout){//after pto
          displayInline = {
            ...displayInline,
            clear: 'both',
            float: 'left',
          };
        }else {
          displayInline = {
            display:'inline-block',
            verticalAlign:'top',
            width: 'auto',
            marginRight:'10px',
          };
        }
        return (
          <Container
            key={container.config ? container.config.id : ('container_'+index)}
            wrapperStyle={container.config.id == 'ptocat' ? {maxWidth:'100%', width:'100%'} : displayInline}
            bodyStyle={container.config.id == 'ptocat' ? displayFlex : {}}
            container={container}
            getZonesWrapper={this.getZonesWrapper.bind(this)}
          />
        );
      });
    }
    return col.containers.map((container, index) =>
      <Container
        key={container.config ? container.config.id : ('container_'+index)}
        container={container}
        getZonesWrapper={this.getZonesWrapper.bind(this)}
      />
    );
  }

  getColumns(cols){
    return cols.map(col =>
      <div key={col.id} className="column" style={col.id == "horizontal_panel" ? {width:'100%'} : {}}>
        {this.getContainers(col)}
      </div>
    );
  }

  renderDialogBox(){
    const { dialog_box } = this.state;
    return (
      <DialogBox
        key={"dialog_box" + dialog_box.uniqueID}
        data={dialog_box.data}
        variables={dialog_box.variables}
        dialog_type={dialog_box.dialog_type}
        onClose={this.closeDialogBox.bind(this)}
        onSuccess={() => this.props.refreshObjects(this.state.screenHeader.seldate)}
        openDialog={this.openDialog.bind(this)}
      />
    );
  }

  navigate({ endpoint, method, variables }){
    dynamicOEButtonCall(`/${endpoint}`, method, variables)
    .then(({ data }) => {
      if(data.ribbon){
        const param = {
          menu: data.ribbon.menu,
          config: data.ribbon.config,
          variables: {
            seldate: data.config.seldate
          },
        };
        this.props.updateRibbon(param, true);
      }
      this.parseData(data);
    });
  }

  renderNav(){
    const { navigation, label, class:extraClass } = this.state.screenHeader;

    const lastParams = {
      endpoint: navigation.last.endpoint,
      method: "GET",
      variables: {
        seldate: navigation.last.seldate,
      },
    };

    const nextParams = {
      endpoint: navigation.next.endpoint,
      method: "GET",
      variables: {
        seldate: navigation.next.seldate,
      },
    };

    return (
      <div className={"operations-board-header " + extraClass}>
        <div className="navigation">
          <span className="navOpt" onClick={this.navigate.bind(this, lastParams)}>{"<< " + navigation.last.label}</span>
          <span className="dayLabel">{label}</span>
          <span className="navOpt" onClick={this.navigate.bind(this, nextParams)}>{navigation.next.label + " >>"}</span>
        </div>
      </div>
    );
  }

  render() {
    if(this.state.cols && this.state.cols.length > 0){
      return (
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="operations-board">
            <APIResponseDialog open={this.state.dialog.open} response={this.state.dialog.response} notify={true}/>
            {this.state.dialog_box.show && this.state.dialog_box.data && this.renderDialogBox()}
            {this.state.screenHeader.navigation && this.renderNav()}
            <div className="operations-board-body">
            {this.getColumns(this.state.cols)}
            </div>
            {this.state.loading && (
              <div style={{position:"absolute"}}>
                <Loading type="spinningBubbles" color="#207cca" height="100px" width="100px" />
              </div>
            )}
          </div>
        </DragDropContext>
      );
    }else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OperationsBoard/OperationsBoard.js